<template>
  <div
    v-if="isShowPage"
    class="bankInfo"
  >
    <van-nav-bar
      :title="lang.title"
      :left-arrow="!$route.query.fromapp"
      @click-left="window.history.go(-1)"
    />
    <div class="card_body">
      <!-- 中国银行 -->
      <div class="card">
        <img
          src="//static.house730.com/m/images/bank1.png"
          alt=""
          width="146"
          height="100"
        >
        <div class="info">
          <p class="bankName">
            {{ lang.bankName1 }}
          </p>
          <p class="num">
            <span class="grey">{{ lang.bankAccount }}: </span><br>
            <span class="space">({{ lang.code }} : 012)</span><br v-if="en">
            <span class="space"> 875-2-035677-8 </span> <br>
            <span class="grey space8">{{ lang.bankAccountName }}: </span><br>
            <span class="space">HOUSE730 LIMITED</span>
          </p>
        </div>
      </div>
      <!-- 恒生银行 -->
      <div class="card">
        <img
          src="//static.house730.com/m/images/bank2.png"
          alt=""
          width="146"
          height="100"
        >
        <div class="info">
          <p class="bankName">
            {{ lang.bankName2 }}
          </p>
          <p class="num">
            <span class="grey">{{ lang.bankAccount }}: </span><br>
            <span class="space">({{ lang.code }} : 024)</span><br v-if="en">
            <!-- <span class="space">228-360681-883</span> <br /> -->
            <span class="space">752-007526-883</span> <br>
            <span class="grey space8">{{ lang.bankAccountName }}: </span><br>
            <span class="space">HOUSE730 LIMITED</span>
          </p>
        </div>
      </div>
      <!-- 滙豐銀行 -->
      <div class="card">
        <img
          src="//static.house730.com/m/images/bank3.png"
          alt=""
          width="146"
          height="100"
        >
        <!-- <img src="./../assets/bank3.png" alt="" width="146" height="100"> -->
        <div class="info">
          <p class="bankName">
            {{ lang.bankName3 }}
          </p>
          <p class="num">
            <span class="grey">{{ lang.bankAccount }}: </span><br>
            <span class="space">({{ lang.code }} : 004)</span><br v-if="en">
            <span class="space"> 023-786478-838 </span> <br>
            <span class="grey space8">{{ lang.bankAccountName }}: </span><br>
            <span class="space">HOUSE730 LIMITED</span>
          </p>
        </div>
      </div>
      <!-- FPS -->
      <div class="card">
        <!-- <img src="//static.house730.com/m/images/bank4.png" alt="" width="146" height="100"> -->
        <img
          src="./../assets/bank4.png"
          alt=""
          width="146"
          height="100"
        >
        <!-- src="./../assets/bank4.png" v-lazy="pub.imgResize('./../assets/bank4.png')" -->
        <div class="info">
          <p class="bankName">
            {{ lang.bankName4 }}
          </p>
          <p class="num">
            <span class="grey">{{ lang.bankAccount }}: </span><br>
            <!-- <span class="space">({{lang.code}})</span><br v-if="en"> -->
            <span class="space"> 3575503 </span> <br>
            <span class="grey space8">{{ lang.bankAccountName }}: </span><br>
            <span class="space">HOUSE730 LIMITED</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pub from '../../common/public';
import lang from './../../common/language/bankInfo'
export default {
  name: "BankInfo",
  data () {
    return {
      isShowPage: false,
      lang,
      en: false,
      isPc: false
    }
  },
  created () {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcUrl}zh-cn/help/paymentmethod/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcUrl}en-us/help/paymentmethod/`;
      } else {
        location.href = `${pub.config.pcUrl}help/paymentmethod/`;
      }
    } else {
      this.isShowPage = true;
    }
    this.en = document.URL.indexOf('en-us') > -1
  }
}
</script>

<style scoped lang="scss">
.bankInfo {
  height: 100%;
  background-color: #f5f7f7;
}
.card_body {
  padding-top: 20px;
  .card {
    margin-bottom: 10px;
  }
}
.card {
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid #eee;

  .grey {
    color: #adadad;
    margin-top: 4px;
  }
  .space {
    margin-top: 4px;
    display: inline-block;
  }
  .space8 {
    display: inline-block;
    margin-top: 8px;
  }
  .info {
    text-align: left;
    font-size: 14px;
    margin-left: 12px;
    .bankName {
      margin-top: 12px;
      border-bottom: 1px solid #f5f7f7;
      padding-bottom: 12px;
      font-weight: 600;
    }
    .num {
      margin-top: 12px;
      margin-bottom: 16px;
      line-height: 22px;
    }
  }
}
</style>
